import initialState from './initialState';
import { types } from '../actions/budgetActions';

export default function budgetVotingReducer(state = initialState.budgetVoting, action) {
  switch (action.type) {
    case types.GET_VOTE_SETTINGS: {
      return {
        fetching: true,
        data: null,
      };
    }
    case types.GET_VOTE_SETTINGS_SUCCESS: {
      const { data } = action;
      return {
        fetching: false,
        data,
      };
    }
    case types.GET_VOTE_SETTINGS_FAILURE: {
      return {
        fetching: false,
        data: null,
      };
    }
    case types.BUDGET_VOTE_SUCCESS: {
      return {
        fetching: false,
        data: Object.assign({}, state.data),
        success: true,
        voteError: null,
      };
    }
    case types.BUDGET_VOTE_ERROR: {
      const { error } = action;
      return {
        fetching: false,
        data: Object.assign({}, state.data),
        success: true,
        voteError: error,
      };
    }
    case types.CLEAR_BUDGET_VOTE_ERROR: {
      return {
        ...state,
        success: false,
        voteError: null,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetVotingReducer.js